import { Injectable } from '@angular/core';
import { ServicingBaseClass } from '@common/components';
import { CommonLibService } from '@lib/services';
import {
  GetDocumentListStore,
  resetGetDocumentList,
  selectGetDocumentListIsFailureStatus,
  selectGetDocumentListState,
  setGetDocumentListFromApi,
} from '@common/store/get-document-list';
import { Store, select } from '@ngrx/store';
import { DefaultService as Api } from 'src/sdk-servicing/api/default.service';
import { Observable } from 'rxjs';
import { filter, map, withLatestFrom, zipWith } from 'rxjs/operators';
import { GetDocumentListRequest, GetDocumentListResponse } from 'src/sdk-servicing';

/**
 * S05-P011_領収書選択 航空券／EMDリスト取得APIとレスポンス管理ストアを操作するためのサービス
 *
 */
@Injectable()
export class GetDocumentListStoreService extends ServicingBaseClass {
  private result$!: Observable<GetDocumentListResponse | null>;
  private failure$!: Observable<boolean>;

  public get res$() {
    return this.result$;
  }

  constructor(private store: Store<GetDocumentListStore>, private api: Api, private common: CommonLibService) {
    super();
    this.result$ = this.store.pipe(
      select(selectGetDocumentListState),
      map((state) => state.model)
    );
    this.failure$ = this.store.pipe(
      select(selectGetDocumentListIsFailureStatus),
      filter((isFailure) => isFailure)
    );
  }

  /**
   * APIの結果をハンドリングします。
   * @param responseHandler APIコールが成功した場合のハンドラ
   * @param errorHandler 失敗した場合のハンドラ
   * @param observableWith APIコールと一緒にsubscribeするObservable (有料サービスマスタのキャッシュなど)
   */
  setupHandler<T>(
    responseHandler: (response: GetDocumentListResponse, responseWith: T) => void,
    errorHandler: (apiErrorCode?: string) => void,
    observableWith: Observable<T>
  ) {
    this.subscribeService(this.result$.pipe(filter(Boolean), zipWith(observableWith)), (result) => {
      responseHandler(result[0], result[1]);
    });
    this.subscribeService(
      this.failure$.pipe(
        withLatestFrom(this.common.apiErrorResponseService.getApiErrorResponse$(), (_, state) => state)
      ),
      (model) => {
        const errors = model?.errors;
        const apiErrorCode = errors && errors.length ? errors[0].code : undefined;

        errorHandler(apiErrorCode);
      }
    );
  }

  callApi(req: GetDocumentListRequest) {
    const call = this.api.ordersGetDocumentListPost(req);
    this.store.dispatch(setGetDocumentListFromApi({ call }));
  }
  /**
   * ストアを空にします。
   */
  clearStore(): void {
    this.store.dispatch(resetGetDocumentList());
  }

  override destroy(): void {}
}
